(function(){
  document.addEventListener('DOMContentLoaded', function() {
    
window.initJsSlideProduct = () => {

  document.addEventListener('click', (event) => {
    // 1. Закрытие по клику на фон (backdrop)
    // Проверяем, что кликнули именно по тегу DIALOG
    if (event.target.tagName === 'DIALOG') {
      event.target.close();
    }

    // 2. Закрытие по любой кнопке с атрибутом data-close-dialog
    // Полезно, если хочешь сделать кастомную кнопку закрытия или крестик
    if (event.target.closest('[data-close-dialog]')) {
      const dialog = event.target.closest('dialog');
      if (dialog) dialog.close();
    }
  });


  // Исправленная функция проигрывания видео
  function isVideoPlay(swiper) {
    const activeSlide = swiper.el.querySelector('.swiper-slide-active');
    if (!activeSlide) return;

    const poster = activeSlide.querySelector('.deferred-media__poster');
    const video = activeSlide.querySelector('video');

    // Если есть постер (deferred media), кликаем по нему
    if (poster) {
      poster.click();
      setTimeout(() => {
        const deferredVideo = activeSlide.querySelector('video');
        if (deferredVideo) {
          deferredVideo.play().catch(e => console.warn("Video play blocked:", e));
        }
      }, 500);
    } 
    // Если видео уже в DOM
    else if (video) {
      video.play().catch(e => console.warn("Video play blocked:", e));
    }
  }

  let containerProduct = document.querySelectorAll('product-info');

  containerProduct.forEach(elem => {
  let thumbItem = elem.querySelector('.js-product-thumbnail-slider');
  let mainItem = elem.querySelector('.js-product-main-slider');

  if (!thumbItem || !mainItem) return;

  // Инициализируем превью (Thumbnail Slider)
  let sliderThumbnail = new Swiper(thumbItem, {
    spaceBetween: 15,
    slidesPerView: 4,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    centerInsufficientSlides: true,
    threshold: 10, // КРИТИЧНО: Игнорирует мелкие сдвиги, фиксируя клик
    freeMode: false, // Отключаем, чтобы не было "плавания"
    touchMoveStopPropagation: true,
    breakpoints: {
      320: { slidesPerView: 4 },
      640: { slidesPerView: 6 }
    }
  });

  // Инициализируем главный слайдер
  window.galleryMain = new Swiper(mainItem, {
    initialSlide: mainItem.dataset.type > 1 ? 1 : 0,
    threshold: 5,
    thumbs: {
      swiper: sliderThumbnail 
    },
    on: {
      slideChangeTransitionEnd: function() {
        // changeVariantByImage(this);
        if (this.touches.diff !== 0 || this.navigation.nextEl === document.activeElement || this.navigation.prevEl === document.activeElement) {
           changeVariantByImage(this);
        }
        isVideoPlay(this);
      }
    },
    navigation: {
      nextEl: mainItem.querySelector('.swiper-button-next'),
      prevEl: mainItem.querySelector('.swiper-button-prev'),
    }
  });
});

  /**
   * Синхронизация слайдера при изменении варианта (через селектор)
   */
  let productCur = document.querySelector('[data-tb-variants-json]');
  if (productCur) {
    productCur = JSON.parse(productCur.getAttribute('data-tb-variants-json'));
  }

  function variantImage(val) {
    const selectedVariantId = parseInt(val, 10);
    const variant = productCur.find(v => v.id === selectedVariantId);
    
    if (variant && variant.featured_media) {
      const mediaId = variant.featured_media.id;
      // Ищем слайд, у которого data-for-slick совпадает с ID медиа
      const targetSlide = document.querySelector(`.js-product-main-slider [data-for-slick="${mediaId}"]:not(.swiper-slide-duplicate)`);
      
      if (targetSlide && window.galleryMain) {
        const index = Array.from(targetSlide.parentNode.children).indexOf(targetSlide);
        window.galleryMain.slideTo(index);
      }
    }
  }

  const initialColorVariant = document.querySelector('product-info .product-variant-id');
  initialColorVariant?.addEventListener('change', function() {
    if (this.value) variantImage(this.value);
  });

  /**
   * Смена варианта при клике/свайпе слайда
   */
  function changeVariantByImage(swiper) {
    let productObj = document.querySelector('[data-tb-variants-json]');
    if (!productObj) return;
    productObj = JSON.parse(productObj.getAttribute('data-tb-variants-json'));

    const activeSlide = swiper.slides[swiper.activeIndex];
    const mediaId = activeSlide?.getAttribute('data-for-slick');

    if (!mediaId) return;

    let selectedVariantId = parseInt(mediaId, 10);
    let variant = productObj.find(v => v.featured_media?.id === selectedVariantId && v.available);

    if (variant) {
      variant.options.forEach(option => {
        // Ищем input/radio и имитируем клик
        const inputOption = document.querySelector(`input[value="${option.replace(/"/g, '\\"')}"] + label`);
        if (inputOption) inputOption.click();
      });
    }
  }
};

    window.initJsSlideProduct();

        
 }, false);
})();
